import { DealStatus } from 'components/common/types/Deal.types';

export const isReadOnly = (
  bookingStatusCode,
  isEditingDisabled,
  isLineTerminated = false,
  isEditingAllowed = false,
) => {
  if (isEditingAllowed) {
    return isEditingDisabled || isLineTerminated;
  }

  return (
    isEditingDisabled ||
    isLineTerminated ||
    [DealStatus.ENDED, DealStatus.CANCELLED, DealStatus.TERMINATED].includes(bookingStatusCode)
  );
};
